import(/* webpackMode: "eager", webpackExports: ["LocaleSwitcher"] */ "/repo/apps/klant/src/components/locale-switcher.tsx");
